import { Injectable } from "@angular/core";
import { Cst } from "src/app/models/Taxation/Cst.model";
import { Taxation } from "src/app/models/Taxation/Taxation.model";
import { ValidCfop } from "src/app/models/Taxation/ValidCfop.model";
import { ApiService } from "../api/api.service";
import { TaxationSelect } from "src/app/models/Taxation/TaxationSelect.model";
import { CbsIbsModel } from "src/app/models/Taxation/cbs.model";
import { CClasstribEntity as CClasstribModel, TaxRuleCclasstribTaxationCreate, TaxRuleCclasstribTaxationList, TaxRulesClasstribEntity } from "src/app/models/Taxation/CClasstribEntity.model";
import { AlertMessageService } from "../alert-message/alert-message.service";
import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom, iif, map, Observable } from "rxjs";
import { DialogAlreadyExistsComponent } from "src/app/modals/dialog-already-exists/dialog-already-exists.component";
import { SessionService } from "../session/session.service";


@Injectable({
    providedIn: 'root'
})
export class TaxationService {

    constructor(private api: ApiService,private alertMessage: AlertMessageService,private dialog: MatDialog,private session:SessionService) {
    }

    codes: string[] = [
    "000001",
    "200002",
    "200003",
    "200004",
    "200006",
    "200007",
    "200009",
    "200010",
    "200012",
    "200013",
    "200014",
    "200015",
    "200020",
    "200030",
    "200031",
    "200032",
    "200033",
    "200034",
    "200035",
    "200036",
    "200038",
    "200044",
    "200047",
    "410001",
    "410003",
    "410005",
    "410006",
    "410007",
    "410008",
    "410009",
    "410012",
    "410014",
    "410019",
    "410020",
    "410026",
    "410029",
    "410999"
    ];

    
    public async validateNcm(ncm: number): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/v1/taxation/validate-ncm', {ncm: ncm});
            if(!r.success) {
                console.error(r);
                return false;
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }

    public async validateCfop(cfop: number): Promise<ValidCfop> {
        try {
            const r = await this.api.get<ValidCfop>('/v1/taxation/validate-cfop', {cfop: cfop});
            if(!r.success) {
                console.error(r);
                return {valid: false, isSubstitution: false};
            }
            return r.data;   
        } catch (error) {
            throw(error);
        }
    } 

    public async validateCsosn(cfop: number, csosn: number): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/v1/taxation/validate-csosn', {cfop: cfop, csosn: csosn});
            if(!r.success) {
                console.error(r);
                return false;
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }
    
    public async validateCest(cest: string, csosn: number): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/v1/taxation/validate-cest', {cest: cest.split('.').join(''), csosn: csosn});
            if(!r.success) {
                console.error(r);
                return false;
            }
            return r.data;   
        } catch (error) {
            throw(error);
        }
    } 

    public async saveTaxationRule(taxation: Taxation): Promise<number> {
        try {
            const r = await this.api.post<number>('/v1/taxation', taxation);
            if(!r.success) {
                console.error(r);
                return 0
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }

    public async getTaxationRules(): Promise<Taxation[]> {
        try {
            const r = await this.api.get<Taxation[]>('/v1/taxation');
            if(!r.success) {
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }

    public async getDefaultTaxationRuless(): Promise<TaxationSelect[]> {
        try {
            const r = await this.api.get<TaxationSelect[]>('/v1/taxation/default');
            if(!r.success) {
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }

    public async saveDefaultTaxationRules(rules: number[]): Promise<boolean> {
        const r = await this.api.post<number>('/v1/taxation/default', {taxationRules: rules} );
        
        if(!r.success)
            console.error(r);

        return r.success;
    }

    public async getCstCofins(): Promise<Cst[]> {
        try {
            const r = await this.api.get<Cst[]>('/v1/taxation/cst-cofins');
            if(!r.success) {
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }

    public async getCstPis(): Promise<Cst[]> {
        try {
            const r = await this.api.get<Cst[]>('/v1/taxation/cst-pis');
            if(!r.success) {
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            throw(error);
        }
    }
        public async getCbs(): Promise<CbsIbsModel[]> {
        try {
            const r = await this.api.get<CbsIbsModel[]>('/v1/taxation/cbs');
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
            public async getIbsCity(): Promise<CbsIbsModel[]> {
        try {
            const r = await this.api.get<CbsIbsModel[]>('/v1/taxation/ibs-city');
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }   
        public async getIbsState(): Promise<CbsIbsModel[]> {
        try {
            const r = await this.api.get<CbsIbsModel[]>('/v1/taxation/ibs-state');
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
        public async createCbs(cbs: CbsIbsModel): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>('/v1/taxation/cbs', cbs);
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false
            }
            this.alertMessage.alertSuccessMessage('CBS cadastrado com sucesso!')
            return r.data;

        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
        public async createIbsState(IbsState: CbsIbsModel): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>('/v1/taxation/ibs-state', IbsState);
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false
            }
            this.alertMessage.alertSuccessMessage('IBS Estadual cadastrado com sucesso!')
            return r.data;

        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
        public async createIbsCity(ibsCity: CbsIbsModel): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>('/v1/taxation/ibs-city', ibsCity);
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false
            }
            this.alertMessage.alertSuccessMessage('IBS Municipal cadastrado com sucesso!')
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
    //

    public async createTaxRuleCClasstrib(tax: TaxRuleCclasstribTaxationCreate): Promise<number> {
        try {
            const r = await this.api.post<number>('/v1/taxation/txt-rule-cclasstrib', tax);
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return 0
            }
            this.alertMessage.alertSuccessMessage(`Regra ${tax.name} cadastrada com sucesso!`);
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
    //tax-rule-cclasstrib-axation
        public async createTaxRuleCClasstribTaxation(tax: TaxRulesClasstribEntity): Promise<number> {
        try {
            const r = await this.api.post<number>('/v1/taxation/tax-rule-cclasstrib-taxation', tax);
            if(!r.success) {
                this.getMensagemErro(r);

                console.error(r);
                return 0
            }
            this.alertMessage.alertSuccessMessage(`O período foi cadastrado com sucesso!`)
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
    
    public async geTaxRuleCClasstrib(): Promise<TaxRuleCclasstribTaxationList[]> {
        try {
            const r = await this.api.get<TaxRuleCclasstribTaxationList[]>('/v1/taxation/txt-rule-cclasstrib');
            if(!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return [];
            }
            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw(error);
        }
    }
    
    public async disableTaxRuleCClasstribTaxation(id: number): Promise<boolean> {
        try {
            const canDisable = await firstValueFrom(
                this.openDialogOkCancel("Você realmente deseja inativar este período?", "Inativar")
            );

            if (!canDisable) return false;

            const r = await this.api.put<boolean>(`/v1/taxation/tax-rule-cclasstrib-taxation/disable/${id}`, null);
            if (!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false;
                
            }
            this.alertMessage.alertSuccessMessage('Período inativado com sucesso!');

            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw error;
        }
    }
    public async geTaxRuleCClasstribTaxation(id:number): Promise<TaxRulesClasstribEntity[]> {
            try {
                const r = await this.api.get<TaxRulesClasstribEntity[]>(`/v1/taxation/tax-rule-cclasstrib-taxation/${id}`);
                if(!r.success) {
                    this.getMensagemErro(r);
                    console.error(r);
                    return [];
                }
                return r.data;
            } catch (error) {
                this.getMensagemErro(error);
                throw(error);
            }
        }
    public async getCclasstrib(): Promise<CClasstribModel[]> {
            try {
                const r = await this.api.get<CClasstribModel[]>('/v1/taxation/cclasstrib');
                if(!r.success) {
                    this.getMensagemErro(r);
                    return [];
                }
                
                const filterData= this.filterValidData(r.data);


                return filterData;
            } catch (error) {
                this.getMensagemErro(error);
                throw(error);
            }
        }

    getMensagemErro(error: any) {

        if (typeof error === "string") {
                return;
        }
        if(!this.session.token|| this.session.token.length==0){
                return;
            }

        if (!error || !error.statusCode) {
        this.alertMessage.alertErrorMessage('Erro desconhecido ao processar a resposta.');
        return;
        }

        const status = error.statusCode;

        // 1. Erro de conexão
        if (status === 0 ) {
            this.alertMessage.alertErrorMessage('Não foi possível conectar com o servidor.');
            return;
        }

        // 2. Erro interno
        if (status === 500) {
        this.alertMessage.alertErrorMessage('Erro interno no servidor. Tente novamente mais tarde.');
        return;
        }

        // 3. Erro de validação
        if ((status === 400 || error.messageCode==-2)  && error.data) {
        {
            let primeiraMensagem="";
            //primeiraMensagem = ( || error.messageCode==-2)?error.data[1]?.message:error.data[0]?.message;
            if(error.data[0]?.property=="command"){
                primeiraMensagem =error.data[1]?.message;
            }
            else if(error.messageCode==-2) {
                primeiraMensagem =error.data;
            }
            else{
                primeiraMensagem =error.data[0]?.message;
            }

            if (primeiraMensagem) {
                this.alertMessage.alertWarningMessage(primeiraMensagem);
                return;
            }
        }


        }

    }

   openDialogOkCancel(message: string, title: string): Observable<boolean> {
    
      const dialog = this.dialog.open(DialogAlreadyExistsComponent, {
        data: {
          title,
          message
        },
        panelClass: 'mat-dialog-alert'
      })
      return dialog.afterClosed().pipe(map(result => {
        if (result && result.includes('yes')) {
          return true;
        }
        return false;
      }))
    }

    public async disableCbs(id: number): Promise<boolean> {
        try {
            const canDisable = await firstValueFrom(
                this.openDialogOkCancel("Você realmente deseja inativar este período?", "Inativar")
            );

            if (!canDisable) return false;

            const r = await this.api.put<boolean>(`/v1/taxation/cbs/disable/${id}`, null);
            if (!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false;
                
            }
            this.alertMessage.alertSuccessMessage('Período inativado com sucesso!');

            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw error;
        }
    }

        public async disableIbsCity(id: number): Promise<boolean> {
        try {
            const canDisable = await firstValueFrom(
                this.openDialogOkCancel("Você realmente deseja inativar este período?", "Inativar")
            );

            if (!canDisable) return false;

            const r = await this.api.put<boolean>(`/v1/taxation/ibsCity/disable/${id}`, null);
            if (!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false;
                
            }
            this.alertMessage.alertSuccessMessage('Período inativado com sucesso!');

            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw error;
        }
    }

            public async disableIbsState(id: number): Promise<boolean> {
        try {
            const canDisable = await firstValueFrom(
                this.openDialogOkCancel("Você realmente deseja inativar este período?", "Inativar")
            );

            if (!canDisable) return false;

            const r = await this.api.put<boolean>(`/v1/taxation/ibsState/disable/${id}`, null);
            if (!r.success) {
                this.getMensagemErro(r);
                console.error(r);
                return false;
                
            }
            this.alertMessage.alertSuccessMessage('Período inativado com sucesso!');

            return r.data;
        } catch (error) {
            this.getMensagemErro(error);
            throw error;
        }

        
    }
     filterValidData(list?: CClasstribModel[]): CClasstribModel[] {
        if(!list)
            return [];

        return list
        .filter(r => r.code != null && this.codes.includes(r.code)) // só mantém os que têm code válido
        .map(r => r);
}
}
